export const apiUrl = process.env.VUE_APP_QUALER_ID_API_URL;
export const identityUrl = process.env.VUE_APP_QUALER_ID_URL;
export const clientId = process.env.VUE_APP_QUALER_ID_UI_CLIENT_ID;
export const uiUrl = process.env.VUE_APP_QUALER_ID_UI_URL;
export const menuUrl = process.env.VUE_APP_QUALER_MENU_API_URL;
export const useGTM = process.env.VUE_APP_QUALER_USE_GTM === "true";
export const isDevelopment = process.env.NODE_ENV === "development";
